var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'video.view', params: {id: this.video.id, slug: this.video.slug}}}},[(_vm.thumbnail)?_c('b-img-lazy',{attrs:{"fluid":"","src":_vm.thumbnail,"alt":_vm.video.description}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }